import { FC, ReactNode } from 'react';
import { dibsLazyClient } from 'dibs-lazy/src/dibsLazyClient';
import { ClientSuspense } from 'dibs-elements/src/ClientSuspense';

// components
import { FormattedMessage } from 'dibs-react-intl';

// styles
import styles from './PdpRespSharedBuyerAssuranceBenefits.scss';

// lazy components
const Checkmark = dibsLazyClient(
    () => import(/* webpackChunkName: "Checkmark" */ 'dibs-icons/exports/Checkmark')
);

const Benefit: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <div className={styles.benefit}>
            <ClientSuspense fallback={null}>
                <Checkmark className={styles.icon} />
            </ClientSuspense>
            <p className={styles.text}>{children}</p>
        </div>
    );
};

export const Vetted = (
    <Benefit>
        <FormattedMessage
            id="PdpRespSharedBuyerAssuranceBenefits.vetted"
            defaultMessage="Expertly Vetted Sellers"
        />
    </Benefit>
);

export const Protection = (
    <Benefit>
        <FormattedMessage
            id="PdpRespSharedBuyerAssuranceBenefits.protection"
            defaultMessage="Buyer Protection"
        />
    </Benefit>
);
export const Delivery = (
    <Benefit>
        <FormattedMessage
            id="PdpRespSharedBuyerAssuranceBenefits.delivery"
            defaultMessage="Trusted Global Delivery"
        />
    </Benefit>
);

export const PriceMatch = (
    <Benefit>
        <FormattedMessage
            id="PdpRespSharedBuyerAssuranceBenefits.priceMatch"
            defaultMessage="Price-Match Guarantee"
        />
    </Benefit>
);

export const Confidence = (
    <Benefit>
        <FormattedMessage
            id="PdpRespSharedBuyerAssuranceBenefits.confidence"
            defaultMessage="Confidence at Checkout"
        />
    </Benefit>
);

export const Support = (
    <Benefit>
        <FormattedMessage
            id="PdpRespSharedBuyerAssuranceBenefits.support"
            defaultMessage="Exceptional Support"
        />
    </Benefit>
);
